module.exports = __webpack_public_path__ + "img/itunes.dffcb62.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/assistant/itunes.svg
// module id = ./assets/assistant/itunes.svg
// module chunks = 10